module.exports = __webpack_public_path__ + "img/newspaper.b1c07448.svg";